import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/modal-exit/whatsapp-v1.svg")